import React from "react";
import locationImage from "../../../../images/icon-location@2x.png";
import {AuthorDetails, AuthorDetailsIcon} from "./AuthorDetails";

export const AuthorLocation = ({authorDetails}) => {
    const {location: {city, country}} = authorDetails;

    return <AuthorDetails>
        <AuthorDetailsIcon src={locationImage}/>
        <div className="t-location">{city + ', ' + country}</div>
    </AuthorDetails>;
}